import React from 'react';
import './PerformanceList.scss';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  organizer: string;
  setRef: (node: HTMLElement) => void;
}

const PerformanceList: React.SFC<IProps> = ({
  organizer,
  setRef,
  children,
}) => (
  <div className='performance-list' ref={ setRef }>
    <WrapperLayout padding='md'>
      <FormattedText 
        style='performance-list-title'
        displayName='Biljetter'
        formattedName='event.tickets'  
      />
      <div className='performance-organizer'>
        <FormattedText 
          style='sub-title'
          displayName='Arrangör'
          formattedName='event.organizer'  
        />
        <span>{ organizer }</span>
      </div>
      <div className='list'>
        { children }
      </div>
    </WrapperLayout>
  </div>
);

export default PerformanceList;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/PerformanceList/PerformanceList.tsx